<div class="more-actions" [class.open]="isOpen">
  <button *ngIf="!isOpen"
          class="more-actions-open-button"
          (click)="togglePanel.emit()">
    <svg-icon icon="ellipsis"></svg-icon>
  </button>

  <ng-container *ngIf="isOpen">
    <div class="more-actions-content-container" [@slideInFromBottomAnimation]>
      <ng-content></ng-content>
    </div>

    <!-- Keep close button as the last focusable element to ensure tab navigation order without defining tabindex -->
    <button class="more-actions-close-button" (click)="togglePanel.emit()">
      <svg-icon icon="x" class="icon-close"></svg-icon>
    </button>
  </ng-container>
</div>
